import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../services/shared/user.service';
import { map } from 'rxjs/operators';
import { RoutingService } from '../services/routing.service';
@Injectable({
  providedIn: 'root'
})
export class LpOnboardingRequiredGuard  {

  constructor(
    private userService: UserService, 
    private router: Router,
    private routingService: RoutingService) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot):
    boolean |
    UrlTree |
    Observable<boolean | UrlTree> |
    Promise<boolean | UrlTree> {

    return this.userService.accountDetails$.pipe(
      map(clientDetails => {
        const isTransferToOnboardingPage = clientDetails.isLpOnboardingRequired && !clientDetails.isLpOnboardingFilled;
        if (isTransferToOnboardingPage) {
          return this.router.parseUrl(this.routingService.lpOnboardingPageDefault);
        }
        return true;
      })
    );
  }
}
